"use client"

import { useState, useLayoutEffect, useRef } from "react"
import * as Popover from "@radix-ui/react-popover"
import { CaretDown as ChevronDown } from "@phosphor-icons/react"

function DateColumn({ label, values, selected, choose }: { label: string; values: number[]; selected: number | null; choose: (v: number) => void }) {
  const list = useRef<HTMLDivElement>(null)
  useLayoutEffect(() => {
    const node = list.current
    const button = node?.querySelector<HTMLButtonElement>('[aria-pressed="true"]')
    if (node && button) node.scrollTop = button.offsetTop - (node.clientHeight - button.clientHeight) / 2
    // Initial positioning only: clicking must never move the target under the pointer.
  }, [])
  return <section className="expiry-cascade-column" aria-label={label}>
    <strong>{label}</strong>
    <div ref={list}>{values.map(v => <button type="button" key={v} aria-pressed={v === selected} onClick={() => choose(v)}>{v}{label}</button>)}</div>
  </section>
}

export function ExpiryDateCascader({ value, onChange }: { value: string; onChange: (date: string) => void }) {
  const [open, setOpen] = useState(false)
  const [year, setYear] = useState<number | null>(null)
  const [month, setMonth] = useState<number | null>(null)
  const parts = value.split("-").map(Number)
  const currentYear = new Date().getFullYear()
  const firstYear = Math.min(currentYear - 5, parts[0] || currentYear)
  const lastYear = Math.max(currentYear + 30, parts[0] || currentYear)
  const days = year && month ? new Date(year, month, 0).getDate() : 0
  const column = (label: string, values: number[], selected: number | null, choose: (v: number) => void) => (
    <DateColumn label={label} values={values} selected={selected} choose={choose}/>
  )
  return <Popover.Root modal open={open} onOpenChange={v => { setOpen(v); if (v) { setYear(parts[0] || null); setMonth(parts[1] || null) } }}>
    <Popover.Trigger asChild><button id="expireDate" type="button" className="expiry-cascade-trigger" aria-label="选择到期日期">
      <span>{value ? parts[0] + "年 / " + parts[1] + "月 / " + parts[2] + "日" : "选择年 / 月 / 日"}</span><ChevronDown size={16}/>
    </button></Popover.Trigger>
    <Popover.Portal><Popover.Content className="expiry-cascade-menu" align="start" sideOffset={6} collisionPadding={12} onOpenAutoFocus={e => e.preventDefault()}>
      {column("年", Array.from({ length: lastYear - firstYear + 1 }, (_, i) => firstYear + i), year, v => { setYear(v); setMonth(null) })}
      {year ? column("月", Array.from({ length: 12 }, (_, i) => i + 1), month, setMonth) : <p>请选择年份</p>}
      {year && month ? column("日", Array.from({ length: days }, (_, i) => i + 1), parts[0] === year && parts[1] === month ? parts[2] : null, day => {
        onChange(year + "-" + String(month).padStart(2, "0") + "-" + String(day).padStart(2, "0")); setOpen(false)
      }) : <p>请选择月份</p>}
    </Popover.Content></Popover.Portal>
  </Popover.Root>
}
